stimulusApp.register(
  "sticky-column",
  class extends Stimulus.Controller {
    static targets = ["compensator", "wrapper"]

    #direction = "down"
    #previousScroll = 0
    #topInset = 0
    #bottomInset = 0
    #resizeObserver = null

    connect() {
      const styles = getComputedStyle(this.wrapperTarget)
      this.#topInset = parseFloat(
        styles.getPropertyValue("--sticky-column-top"),
      )
      this.#bottomInset = parseFloat(
        styles.getPropertyValue("--sticky-column-bottom"),
      )
      this.#previousScroll = window.scrollY
      this.#resizeObserver = new ResizeObserver(() =>
        requestAnimationFrame(() => this.fit()),
      )
      this.#resizeObserver.observe(this.wrapperTarget)
    }

    disconnect() {
      this.#resizeObserver.disconnect()
    }

    fit() {
      if (this.#fitsViewport) {
        this.#direction = "down"
        this.compensatorTarget.style.marginTop = ""
        this.wrapperTarget.style.top = ""
        this.wrapperTarget.style.bottom = ""
        return
      }

      this.#freeze()
      this.#stick()
    }

    reposition() {
      const scroll = window.scrollY
      const direction = scroll < this.#previousScroll ? "up" : "down"
      this.#previousScroll = scroll

      if (direction === this.#direction || this.#fitsViewport) return

      this.#direction = direction
      this.#freeze()
      this.#stick()
    }

    get #fitsViewport() {
      return (
        this.#height < window.innerHeight - this.#topInset - this.#bottomInset
      )
    }

    get #height() {
      return this.wrapperTarget.getBoundingClientRect().height
    }

    #freeze() {
      this.compensatorTarget.style.marginTop = `${this.wrapperTarget.offsetTop}px`
    }

    #stick() {
      const inset =
        this.#direction === "down" ? this.#bottomInset : this.#topInset
      const offset = `${window.innerHeight - this.#height - inset}px`
      const { style } = this.wrapperTarget

      style.top = this.#direction === "down" ? offset : "auto"
      style.bottom = this.#direction === "down" ? "" : offset
    }
  },
)
